import React from "react";
import { trackPageViewV2 } from "@/services/analytics-adapter";
import HealthScorePageContainer from "../HealthScorePageContainer";
import { Stack, Typography } from "@mui/material";
import VitalsCategory from "../../components/VitalsCategory";
import LifestyleCard from "../../components/LifestyleCard";
import HealthHistoryCard from "../../components/HealthHistoryCard";
import MentalWellbeingCard from "../../components/MentalWellbeingCard";
import HowItWorksModal from "../../components/HowItWorksModal";
import { submitMemberAcknowledgeEvent } from "@/services/core-api-adapter";
import { useGlobalStore } from "@/store";
import { useTranslation } from "react-i18next";
import WellnessWheel from "../../components/WellnessWheel";
import { persistValue, retrieveValue } from "@/store/persistence";

export default function HealthScorePage() {
  const { t } = useTranslation();
  const pageTitle = t("HealthScorePage.title");
  const pageDescription = t("HealthscorePage.description");
  const sectionSubtitle = t("HealthScorePage.section.subtitle");
  const sectionDescription = t("HealthScorePage.section.description");
  trackPageViewV2({
    pageName: "Home:Dashboard",
    pageSubSection1: "Home",
    pageSubSection2: "Home:Dashboard",
    pageCategory: "Home",
  });

  const { state } = useGlobalStore();
  const [isModalOpen, setIsModalOpen] = React.useState(
    !state.hasSeenHealthScorePopUp || !retrieveValue("hasSeenHealthScorePopUp")
  );
  const [healthScore, setHealthScore] = React.useState<number | undefined>(
    undefined
  );

  React.useEffect(() => {
    // TODO: Fetch health score from SDK
    setHealthScore(62);
  }, []);

  return (
    <React.Fragment>
      <HealthScorePageContainer
        title={pageTitle}
        description={pageDescription}
        showBottomNavigation={true}
        healthScore={healthScore}
      >
        <Stack>
          <Stack>
            {!!healthScore && healthScore <= 12 && (
              <Stack>
                <Typography variant="h2">{sectionSubtitle}</Typography>
                <Typography variant="body1">{sectionDescription}</Typography>
              </Stack>
            )}
            {/* TODO: Update category scores */}
            {!!healthScore && healthScore > 12 && (
              <WellnessWheel
                score={healthScore}
                vitals={{ enabled: true, categoryScore: 50 }}
                lifestyle={{ enabled: true, categoryScore: 80 }}
                health={{ enabled: true, categoryScore: 0 }}
                info={{ enabled: true, categoryScore: 100 }}
                mentalHealth={{ enabled: true, categoryScore: 0 }}
              />
            )}
            <Stack gap={2} mt={4}>
              <VitalsCategory />
              <LifestyleCard />
              <HealthHistoryCard />
              <MentalWellbeingCard />
            </Stack>
          </Stack>
        </Stack>
      </HealthScorePageContainer>
      {isModalOpen && (
        <HowItWorksModal
          isOpen={isModalOpen}
          handleClose={async (isDoNotShowThisAgain) => {
            if (isDoNotShowThisAgain)
              submitMemberAcknowledgeEvent("HEALTH_SCORE_POPUP").then(() =>
                persistValue("hasSeenHealthScorePopUp", true)
              );
            setIsModalOpen(false);
          }}
        />
      )}
    </React.Fragment>
  );
}
